import PermissionCheckbox from './PermissionCheckbox';

export default PermissionCheckbox;
